// export const baseUrl =
//   "https://uditsolutions.in/ajivasan-backend/public/api/v1";

export const baseUrl =
  "https://ajivasanmusicacademy.com/ajivasan-backend/public/api/v1";
